/* BOX IMPORT — Botón "+ Agregar" de los sugeridos del carrito (snippets/bi-sugeridos-carrito.liquid)
   y window.biAgregarAlCarrito(items): agrega productos y actualiza el carrito sin recargar la página
   (recargar hace que Safari en iPhone muestre el aviso de "reducir protecciones"). */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
if (!window.biSugeridosListo) {
  window.biSugeridosListo = true;

  const abrirCarrito = () => {
    const d = document.querySelector('#shopify-section-cart-drawer-section dialog, cart-drawer-component dialog');
    if (d && !d.open) { try { d.showModal(); } catch (e) {} }
  };

  /* items: [{ id: varianteId, quantity }]. Devuelve { ok, mensaje }. */
  window.biAgregarAlCarrito = async (items, { abrir = false } = {}) => {
    const secciones = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const diferido = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'cart', lines: items.map((x) => ({ merchandiseId: String(x.id), quantity: x.quantity })), promise: diferido.promise,
    }));
    try {
      const r = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map((x) => ({ id: Number(x.id), quantity: x.quantity })), sections: secciones.join(','), sections_url: location.pathname }),
      });
      const res = await r.json();
      const carrito = await (await fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } })).json();
      if (res.status) {
        document.dispatchEvent(new CartErrorEvent({ error: res.description || res.message || 'No se pudo agregar', code: 'INVALID' }));
        diferido.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito), detail: { didError: true, items: carrito.items } });
        return { ok: false, mensaje: res.description || res.message || 'No se pudo agregar' };
      }
      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
        detail: { items: carrito.items, itemCount: carrito.item_count, sections: res.sections, source: 'bi-sugeridos', didError: false },
      });
      if (abrir) setTimeout(abrirCarrito, 150);
      return { ok: true };
    } catch (err) {
      diferido.reject(err);
      return { ok: false, mensaje: 'No pudimos conectar con la tienda. Probá de nuevo.' };
    }
  };

  /* updates: { claveDeLínea: cantidad }. Cambia cantidades (0 = quitar) y actualiza el carrito sin recargar. Devuelve true si salió bien. */
  window.biActualizarCarrito = async (updates) => {
    const secciones = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const diferido = CartLinesUpdateEvent.createPromise();
    try {
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'update', context: 'cart', lines: Object.entries(updates).map(([id, quantity]) => ({ id, quantity })), promise: diferido.promise,
      }));
    } catch (e) {}
    try {
      const r = await fetch(Theme.routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: secciones.join(','), sections_url: location.pathname }),
      });
      const res = await r.json();
      const carrito = await (await fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } })).json();
      if (!r.ok || res.status) { diferido.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito), detail: { didError: true, items: carrito.items } }); return false; }
      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
        detail: { items: carrito.items, itemCount: carrito.item_count, sections: res.sections, source: 'bi-mixto', didError: false },
      });
      return true;
    } catch (err) {
      diferido.reject(err);
      return false;
    }
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bi-sug-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-cargando');
    const r = await window.biAgregarAlCarrito([{ id: btn.dataset.biSugAdd, quantity: 1 }]);
    if (!r.ok) {
      btn.disabled = false;
      btn.classList.remove('is-cargando');
      if (r.mensaje !== 'No pudimos conectar con la tienda. Probá de nuevo.') btn.querySelector('.bi-sug__btn-txt').textContent = 'Sin stock';
    }
  });
}

/* BOX IMPORT — Tarjetas de producto: porcentaje de descuento real, ahorro en pesos, botón "Ver producto"
   y aparición suave al hacer scroll. Funciona también con las tarjetas que se cargan después (filtros, más productos). */
if (!window.biTarjetasListo) {
  window.biTarjetasListo = true;
  const aNumero = (t) => Number(String(t).replace(/[^\d,]/g, '').split(',')[0]);
  const pesos = (n) => '$' + n.toLocaleString('es-AR');
  const visto = 'IntersectionObserver' in window
    ? new IntersectionObserver((entradas) => entradas.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('bi-in'); visto.unobserve(e.target); }
      }), { rootMargin: '0px 0px -6% 0px' })
    : null;

  const mejorar = () => {
    document.querySelectorAll('.product-card:not([data-bi-card])').forEach((card, i) => {
      card.dataset.biCard = '1';
      /* Precios sin los centavos: $47.990 en vez de $47.990,00 */
      card.querySelectorAll('product-price bdi').forEach((b) => { b.textContent = b.textContent.replace(/,00\s*$/, ''); });
      const precio = card.querySelector('product-price .price bdi');
      const antes = card.querySelector('product-price .compare-at-price bdi');
      if (precio && antes) {
        const p = aNumero(precio.textContent), a = aNumero(antes.textContent);
        if (a > p && p > 0) {
          const insignia = card.querySelector('.product-badges__badge');
          if (insignia) insignia.textContent = '-' + Math.round(((a - p) / a) * 100) + '%';
          const ahorro = document.createElement('span');
          ahorro.className = 'bi-card-ahorro';
          ahorro.textContent = 'Ahorrás ' + pesos(a - p);
          card.querySelector('product-price').after(ahorro);
        }
      }
      /* Botón "Ver producto": es un enlace real al producto (el resto de la tarjeta ya enlaza desde la foto y el título) */
      const contenido = card.querySelector('.product-card__content');
      const enlace = card.querySelector('a.product-card__link, a[href*="/products/"]');
      if (contenido && enlace) {
        const cta = document.createElement('a');
        cta.className = 'bi-card-cta';
        cta.href = enlace.getAttribute('href');
        cta.tabIndex = -1;
        cta.style.pointerEvents = 'auto';
        cta.style.textDecoration = 'none';
        cta.style.position = 'relative';
        cta.style.zIndex = '2';
        cta.innerHTML = 'Ver producto <i>→</i>';
        contenido.appendChild(cta);
      }
      card.style.setProperty('--bi-retraso', (i % 4) * 70 + 'ms');
      if (visto) visto.observe(card); else card.classList.add('bi-in');
    });
  };

  document.documentElement.classList.add('bi-js');
  mejorar();
  let espera;
  new MutationObserver(() => { clearTimeout(espera); espera = setTimeout(mejorar, 120); }).observe(document.body, { childList: true, subtree: true });
}

/* ===== BOX IMPORT: datos de envío obligatorios para productos de Pagá en la Puerta =====
   Maneja el formulario [data-bi-dir] (snippets/bi-sugeridos-carrito.liquid): provincia, localidad de la lista de cobertura y dirección.
   En el carrito no deja ir al checkout hasta completarlo; al seguir guarda los datos en el pedido y abre el checkout con la dirección cargada.
   Con data-modo="consulta" funciona como buscador "¿Llega a tu zona?" en la ficha del producto. */
(() => {
  if (window.__biDir) return;
  window.__biDir = true;
  const KEY = 'bi-dir-v1';
  let DATA = null;
  const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();
  const load = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const save = (d) => { try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} };
  const data = () => {
    if (DATA) return DATA;
    const el = document.querySelector('script[data-bi-loc]');
    DATA = {};
    if (!el) return DATA;
    el.textContent.trim().split('\n').forEach((line) => {
      const i = line.indexOf('=');
      if (i < 1) return;
      DATA[line.slice(0, i).trim()] = line.slice(i + 1).split('|').filter(Boolean).map((s) => {
        const j = s.lastIndexOf(':');
        return [s.slice(0, j).trim(), s.slice(j + 1).trim()];
      });
    });
    return DATA;
  };
  const find = (prov, txt) => {
    const n = norm(txt);
    if (!prov || !n) return null;
    return (data()[prov] || []).find((x) => norm(x[0]) === n) || null;
  };

  const setup = (box) => {
    if (box.__bi) return;
    box.__bi = true;
    const p = box.querySelector('[data-prov]');
    const l = box.querySelector('[data-loc]');
    const d = box.querySelector('[data-dir]');
    const dl = box.querySelector('[data-loc-list]');
    const m = box.querySelector('[data-msg]');
    const id = 'bi-loc-' + Math.random().toString(36).slice(2);
    dl.id = id;
    l.setAttribute('list', id);
    const fill = () => {
      dl.innerHTML = '';
      const frag = document.createDocumentFragment();
      (data()[p.value] || []).forEach((x) => { const o = document.createElement('option'); o.value = x[0]; frag.appendChild(o); });
      dl.appendChild(frag);
      l.disabled = !p.value;
    };
    const consulta = box.getAttribute('data-modo') === 'consulta';
    const check = (strict) => {
      const hit = find(p.value, l.value);
      let msg = '';
      if (!p.value) msg = 'Elegí tu provincia.';
      else if (!hit) msg = l.value.trim()
        ? 'No encontramos "' + l.value.trim() + '" entre las zonas de Pagá en la Puerta de ' + p.options[p.selectedIndex].text + '. Elegila de la lista (probá con tu barrio o localidad). Si no aparece, por ahora no llegamos con pago al recibir a tu zona: podés comprar productos de Envío Inmediato, que llegan a todo el país.'
        : 'Escribí tu localidad o barrio y elegila de la lista.';
      else if (!consulta && d.value.trim().length < 5) msg = 'Completá la dirección: calle y número.';
      p.classList.toggle('is-bad', strict && !p.value);
      l.classList.toggle('is-ok', !!hit);
      l.classList.toggle('is-bad', !hit && (strict || (l.value.trim().length > 2 && document.activeElement !== l)));
      d.classList.toggle('is-bad', !consulta && strict && d.value.trim().length < 5);
      const show = strict || hit || (l.value.trim().length > 2 && document.activeElement !== l);
      const okMsg = consulta
        ? '✓ ¡Sí llegamos! Podés comprar productos de Pagá en la Puerta y pagar en efectivo al recibir.'
        : '✓ Llegamos a tu zona con pago al recibir.';
      m.textContent = show ? (msg || okMsg) : '';
      m.classList.toggle('is-ok', !msg);
      save({ p: p.value, l: l.value, d: d.value });
      return msg ? null : { prov: p.value, provName: p.options[p.selectedIndex].text, loc: hit[0], cp: hit[1], dir: d.value.trim() };
    };
    const st = load();
    if (st.p) { p.value = st.p; fill(); l.value = st.l || ''; d.value = st.d || ''; if (l.value) check(false); }
    p.addEventListener('change', () => { l.value = ''; fill(); check(false); if (p.value) l.focus(); });
    l.addEventListener('input', () => check(false));
    l.addEventListener('change', () => { const hit = find(p.value, l.value); if (hit) l.value = hit[0]; check(false); });
    l.addEventListener('blur', () => check(false));
    d.addEventListener('input', () => check(false));
    box.__check = check;
  };

  const scan = () => document.querySelectorAll('[data-bi-dir]').forEach(setup);
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  const isCheckout = (target) => {
    const b = target && target.closest && target.closest('button, a, input[type="submit"]');
    if (!b) return null;
    if (b.name === 'checkout' || b.id === 'checkout') return b;
    const href = b.getAttribute('href') || '';
    if (/\/checkout/.test(href)) return b;
    const f = b.form || b.closest('form');
    if (f && /checkout/.test(f.getAttribute('action') || '') && b.type === 'submit') return b;
    return null;
  };
  const visibleBox = () => {
    const all = [...document.querySelectorAll('[data-bi-dir]:not([data-modo="consulta"])')];
    return all.find((b) => b.offsetParent !== null) || all[0] || null;
  };

  const go = (x) => {
    const attrs = {
      'Envío Pagá en la Puerta - Provincia': x.provName,
      'Envío Pagá en la Puerta - Localidad': x.loc,
      'Envío Pagá en la Puerta - CP': String(x.cp || '').replace(/\D/g, '').slice(0, 4),
      'Envío Pagá en la Puerta - Dirección': x.dir
    };
    const a = 'checkout[shipping_address]';
    const q = [
      a + '[country]=AR',
      a + '[province]=' + encodeURIComponent(x.prov),
      a + '[city]=' + encodeURIComponent(x.loc),
      a + '[zip]=' + encodeURIComponent(String(x.cp || '').replace(/\D/g, '').slice(0, 4)), // BOX IMPORT: CP solo con 4 números (lo pide Dropi)
      a + '[address1]=' + encodeURIComponent(x.dir)
    ].join('&');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .catch(() => {})
      .then(() => { window.location.href = '/checkout?' + q; });
  };

  const intercept = (e) => {
    const b = isCheckout(e.target);
    if (!b) return;
    const box = visibleBox();
    if (!box) return;
    setup(box);
    e.preventDefault();
    e.stopImmediatePropagation();
    const x = box.__check(true);
    if (!x) { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    go(x);
  };
  document.addEventListener('click', intercept, true);
  document.addEventListener('submit', (e) => {
    const s = e.submitter;
    if (s && isCheckout(s)) intercept({ target: s, preventDefault: () => e.preventDefault(), stopImmediatePropagation: () => e.stopImmediatePropagation() });
  }, true);
})();
